<template lang="html">
  <modal name="room-select-modal"
    height="auto" width="416"
    :maxWidth="416" class="room-select-modal"
    @before-open="beforeOpen" top="120"
    :adaptive="true" @closed="closed"
    @opened="opened"
  >
    <div class="modal-container">
      <div class="modal-header bold">
        Specifications - Rooms
      </div>
      <div class="line-break-gray" />
      <div class="modal-body">
        <div>Number of bedrooms</div>
        <div class="gap-1x" />
        <div :id="idBed"></div>
        <div class="gap-3x" />
        <div>Number of bathrooms</div>
        <div class="gap-1x" />
        <div :id="idBath"></div>
        <div class="gap-3x" />
        <div>Other rooms</div>
        <SelectableList
          :options="otherRoomsOption"
          @update-option="updateOption"
        />
        <div class="gap-1x" />
        <input v-if="showOtherInput" v-model="otherInput" />
      </div>
      <div class="line-break-gray" />
      <ModalFooter
        :cancel="() => this.$modal.hide('room-select-modal')"
        :save="save"
      />
    </div>
  </modal>
</template>

<script>
import _ from 'lodash'

import DisableBodyScroll from 'src/mixins/DisableBodyScroll.js'
import ModalFooter from 'src/components/common/modals/shares/ModalFooter.vue'
import SelectableList from 'src/components/common/form/SelectableList.vue'

let uid = 0

export default {
  components: { SelectableList, ModalFooter },
  mixins: [DisableBodyScroll],
  data() {
    return {
      numberOfBedrooms: 0,
      numberOfBathRooms: 1,
      otherRoomsOption: [
        { text: "Kitchen", selected: false },
        { text: "Living room", selected: false },
        { text: "Combined kitchen/living room", selected: false },
        { text: "Laundry room", selected: false },
        { text: "Laundry closet", selected: false },
        { text: "Dining room", selected: false },
        { text: "Small office", selected: false },
        { text: "Mud room", selected: false },
        { text: "Other", selected: false },
      ],
      otherInput: null,
      errors: {},
      idBed: '',
      idBath: '',
      componenId: '',
    }
  },
  methods: {
    beforeOpen(event) {
      this.errors = {};
      this.numberOfBedrooms = event.params.numberOfBedrooms
      this.numberOfBathRooms = event.params.numberOfBathRooms
      this.otherInput = _.find(event.params.rooms, (room) => { return this.otherRoomsOptionText.indexOf(room) == -1 })
      _.each(this.otherRoomsOption, (option) => {
        option.selected = event.params.rooms.indexOf(option.text) > -1
        if (option.text == 'Other') {
          option.selected = this.otherInput != null
        }
      })
    },
    updateOption(option) {
      _.find(this.otherRoomsOption, (o) => { return o.text == option.text }).selected = option.selected
    },
    save() {
      this.$emit('save', {
        numberOfBedrooms: this.numberOfBedrooms,
        numberOfBathRooms: this.numberOfBathRooms,
        rooms: this.rooms,
      })
      this.$modal.hide('room-select-modal')
    },
    opened() {
      window[this.componenId] = this
      // Add dropdown
      this.$nextTick(() => {
        const assetScript = document.createElement('script')

        assetScript.text = `
          new MultiDropdown({
            id: '${this.idBed}',
            placeholder: 'Number of bedrooms',
            options: [
              { id: "1", option: "1" },
              { id: "2", option: "2" },
              { id: "3", option: "3" },
              { id: "4", option: "4" },
            ],
            selectOption: (value) => window['${this.componenId}'].numberOfBedrooms = value.id,
            isMulti: false,
            defaultValueIndex: ${this.numberOfBedrooms}
          });
          new MultiDropdown({
            id: '${this.idBath}',
            placeholder: 'Number of bathrooms',
            options: [
              { id: "1", option: "1" },
              { id: "1.5", option: "1.5" },
              { id: "2", option: "2" },
              { id: "2.5", option: "2.5" },
              { id: "3", option: "3" },
            ],
            selectOption: (value) => window['${this.componenId}'].numberOfBathRooms = value.id,
            isMulti: false,
            defaultValueIndex: ${Math.max(this.numberOfBathRooms/0.5 - 1, 0)}
          });`
        document.head.appendChild(assetScript)
      })
    },
  },
  computed: {
    showOtherInput() {
      return this.otherOption.selected;
    },
    otherOption() {
      return this.otherRoomsOption[this.otherRoomsOption.length - 1]
    },
    otherRoomsOptionText() {
      return _.map(this.otherRoomsOption, 'text')
    },
    rooms() {
      var rooms = _.map(
        _.filter(this.otherRoomsOption, (o) => { return o.selected && o.text != 'Other' }),
      'text')
      if (this.otherOption.selected) {
        return rooms.concat(this.otherInput)
      }

      return rooms;
    }
  },
  beforeMount() {
    this.idBed = 'bedroom-select-modal-dropdown-' + uid.toString()
    this.idBath = 'bathroom-select-modal-dropdown-' + uid.toString()
    this.componenId = 'room-select-modal-' + uid.toString()
    uid += 1
  },
}
</script>
<style lang="scss" scoped>
.modal-body {
  max-height: calc(100vh - 182px);
}
</style>
